import { CurrentFolderContext, ICurrentFolder } from "./CurrentFolderProvider";
import { useContext } from "react";

function useCurrentFolder(): ICurrentFolder {
  const { currentFolderS3ObjectMap, getCurrentFolderS3Object, setCurrentFolderS3Object } = useContext(CurrentFolderContext);
  return { currentFolderS3ObjectMap, getCurrentFolderS3Object, setCurrentFolderS3Object };
}

export default useCurrentFolder;
